import React, { Component } from 'react';
import { Button } from 'primereact/button';
import withRouter from '../../lib/withRouter';
import moment from 'moment';
import './styles.scss';
import Service from '../../services';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../../loadingComponent';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Dialog } from 'primereact/dialog';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { CrossInBox } from '../../svgIcons';

class PreviewConfirmEnrollment extends Component {
    constructor(props) {
        super(props);

        // Initialize service and auth
        this.service = new Service();
        this.toast = null;

        // Get data from navigation state or from props
        const locationState = this.props.location?.state || {};

        this.state = {
            enrollment: locationState.enrollment || this.props.enrollment || {},
            parents: locationState.parents || this.props.parents || [],
            siblings: locationState.siblings || this.props.siblings || [],
            receiptInfo: locationState.receiptInfo || this.props.receiptInfo || {},
            academicCategoryOptions: locationState.academicCategoryOptions || this.props.academicCategoryOptions || [],
            academicSessionOptions: locationState.academicSessionOptions || this.props.academicSessionOptions || [],
            isLoading: false,
            isStudentEnrolledConfirmed: false,
            userCreatedInfo: null,
            isShowFeeStructure: false,
            feeStructureR: [],
            feeStructure: [],
            selectedRFeeStructure: null,
            selectedFeeStructure: null,
            regularFeeStructureDetails: null,
            feeStructureDetails: null,
            isRegularFeeStructureAssigned: false,
            isFeeStructureAssigned: false,
            isFeeDialogMaximized: true,
            isOptedForTransport: false,
            isCredeintalsDisplay: false,
            studentDetails: false,
            isCloseOfFeeStructure: false,
            isAlreadyEnrolled: false
        };
    }

    async componentDidMount() {
        // Check if student is already enrolled
        const { enrollment } = this.state;

        if (enrollment?._id) {
            try {
                const url = `${baseUrlAdmin}/admissions/complete-info?admissionId=${enrollment._id}`;
                const response = await this.service.get(url, true);

                if (response?.res?.data?.stage === 'Confirmed') {
                    // Student is already enrolled, redirect to enrollment index
                    this.toast?.show({
                        severity: 'info',
                        summary: 'Already Enrolled',
                        detail: 'This student is already enrolled. Redirecting to enrollment list...',
                        life: 3000
                    });

                    setTimeout(() => {
                        this.props.navigate('/admission-enrollment');
                    }, 500);

                    // Set flag to prevent button clicks
                    this.setState({ isAlreadyEnrolled: true });
                }
            } catch (error) {
                console.error('Error checking enrollment status:', error);
            }
        }
    }

    // Helper method to get academic category name from UUID
    getAcademicCategoryName = () => {
        const { enrollment, academicCategoryOptions } = this.state;

        // First try to find the name from the options array
        if (enrollment?.academicCategory && academicCategoryOptions?.length > 0) {
            const category = academicCategoryOptions.find(cat => cat.value === enrollment.academicCategory);
            if (category) {
                return category.label;
            }
        }

        // Fallback to existing name fields
        return enrollment?.admissionCategoryName || enrollment?.categoryName || '';
    };

    // Helper method to get academic year code from UUID
    getAcademicYearCode = () => {
        const { enrollment, academicSessionOptions } = this.state;

        console.log('🔍 Debug - getAcademicYearCode called');
        console.log('enrollment.academicSession:', enrollment?.academicSession);
        console.log('academicSessionOptions:', academicSessionOptions);

        // First try to find the code from the options array
        if (enrollment?.academicSession && academicSessionOptions?.length > 0) {
            console.log('Searching for UUID:', enrollment.academicSession);
            const session = academicSessionOptions.find(sess => sess._id === enrollment.academicSession);
            console.log('Found session:', session);
            if (session) {
                const code = session.academicCode || session.academicYear;
                console.log('Returning code:', code);
                return code;
            }
        }

        // Fallback to existing code fields
        const fallback = enrollment?.academicYearCode || enrollment?.enquiry?.academicYearCode || localStorage.getItem('userAcademicYear') || '';
        console.log('Returning fallback:', fallback);
        return fallback;
    };

    onConfirmEnrollment = async () => {
        // Prevent enrollment if already enrolled
        if (this.state.isAlreadyEnrolled) {
            this.toast?.show({
                severity: 'warn',
                summary: 'Already Enrolled',
                detail: 'This student is already enrolled.',
                life: 3000
            });
            return;
        }

        this.setState({ isLoading: true });

        const { enrollment, parents, siblings } = this.state;

        // Validation
        if (!enrollment || !enrollment._id) {
            this.setState({ isLoading: false });
            if (this.toast) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Missing Enrollment Data',
                    detail: 'Enrollment data is not loaded. Please try again.',
                    life: 3000
                });
            }
            return;
        }

        // Fetch complete enrollment info from API
        let admData;
        try {
            const url = `${baseUrlAdmin}/admissions/complete-info?admissionId=${enrollment._id}`;
            const response = await this.service.get(url, true);

            if (response && response.status) {
                admData = response.res.data;
                console.log('Complete admission data fetched:', admData);
            } else {
                console.warn('Failed to fetch complete admission data:', response);
            }
        } catch (error) {
            console.error('Error fetching complete admission data:', error);
            // Continue with enrollment even if this fails
        }

        // Build the payload matching the addUser format from enrollment.js
        let payload = {
            admissionData: admData.enrollment,
            admissionId: enrollment?._id,

            // Academic Information
            academicYear: enrollment?.academicSession,
            academicYearCode: enrollment?.enquiry?.academicYearCode || enrollment?.academicYearCode || localStorage.getItem('userAcademicYear'),
            academicCategory: enrollment?.enquiry?.academicCategory || enrollment?.academicCategory,
            categoryName: enrollment?.enquiry?.admissionCategoryName || enrollment?.admissionCategoryName || this.getAcademicCategoryName(),

            // Branch Information
            branchId: enrollment?.branch,
            branchName: enrollment?.branchName,

            // Board Information
            boardId: enrollment?.board,
            board: enrollment?.boardName,

            // Grade/Class Information
            gradeId: enrollment?.grade,
            grade: enrollment?.gradeName,
            groupId: enrollment?.groupId,
            group: 'NO_GROUP',

            // Student Personal Information
            firstName: enrollment?.firstName,
            middleName: enrollment?.middleName,
            lastName: enrollment?.lastName,
            dateOfBirth: enrollment?.dob,
            gender: enrollment?.gender,

            // Contact Information
            phone_number: enrollment?.contactNo,
            email: enrollment?.emailId,
            stdCountryCode: enrollment?.stdCountryCode,
            stdContactNo: enrollment?.stdContactNo,
            stdEmailId: enrollment?.stdEmailId,

            // Identity Information
            aadharNo: enrollment?.aadharNo || enrollment?.idDetails,
            govtIdType: enrollment?.govtIdType,
            idDetails: enrollment?.idDetails,
            nationality: enrollment?.nationality,

            // Personal Details
            religion: enrollment?.registration?.religion || enrollment?.religion,
            caste: enrollment?.registration?.caste || enrollment?.caste,
            motherTongue: enrollment?.registration?.motherTongue || enrollment?.motherTongue,
            currentLocation: enrollment?.currentLocation,
            identificationMarks: enrollment?.identificationMarks,
            bloodGroup: enrollment?.bloodGroup,

            // Previous School Information
            previousSchool: enrollment?.previousSchool,
            previousBoard: enrollment?.previousBoard,
            previousGrade: enrollment?.previousGrade,

            // Address Information
            addressLine: enrollment?.registration?.addressLine || enrollment?.addressLine,
            houseNum: enrollment?.registration?.houseNum || enrollment?.houseNum,
            streetOrVillage: enrollment?.registration?.streetOrVillage || enrollment?.streetOrVillage,
            mandal: enrollment?.registration?.mandal || enrollment?.mandal,
            cityOrDist: enrollment?.registration?.cityOrDist || enrollment?.cityOrDist,
            state: enrollment?.registration?.state || enrollment?.state,
            pinCode: enrollment?.registration?.pinCode || enrollment?.pinCode,
            area: enrollment?.area,

            // Parent and Family Information
            parentDetails: enrollment?.registration?.parentDetails || parents,
            siblings: enrollment?.registration?.siblings || siblings,
            contactPersonName: enrollment?.parentName || parents[0]?.parentName || '',
            parentContactNo: enrollment?.parentContact || parents[0]?.parentContact || '',

            // Transport Information
            transportRequired: enrollment?.transportRequired,
            requestedStop: enrollment?.requestedStop,

            // Academic History
            prevAcademicDetails: enrollment?.registration?.prevAcademicDetails || enrollment?.prevAcademicDetails,

            // Admission Information
            admissionTest: enrollment?.admissionTest,

            // Admission Dates and Reference Numbers
            admissionDate: enrollment?.enrollmentDate || enrollment?.enrollment?.enrollmentDate || new Date(),
            registrationDate: enrollment?.registrationDate || enrollment?.registration?.registrationDate,
            admissionRefNo: enrollment?.referenceNo,
            applicationNo: enrollment?.applicationId,

            enrollmentAdmDate: enrollment?.enrollmentDate,

            // Counsellor and Referral Information
            counsellorsName: enrollment?.counsellorsName || enrollment?.enquiry?.counsellorsName,
            knowAboutUs: enrollment?.knowAboutUs || enrollment?.enquiry?.knowAboutUs,
            assignCounsellor: enrollment?.assignCounsellor || enrollment?.enquiry?.assignCounsellor,

            remarks: enrollment?.remarks,

            // Documents
            studentPhoto: enrollment?.registration?.studentPhoto ?? enrollment?.application?.studentPhoto ?? enrollment?.studentPhoto,

            // Additional Fields
            customFields: enrollment?.customFields
        };

        console.log('✅✅✅final enrolling payload: ', payload);

        const url = `${baseUrlAdmin}/user/addUser`;

        let userToSave = {
            ...payload,
            phone_number: `+${parents[0]?.countryCode || '91'}${payload.phone_number}`
        };

        this.service
            .post(url, userToSave, true)
            .then((res) => {
                console.log('🔍 addUser API Response:', res);

                if (res && res.status && res.res.status) {
                    this.setState(
                        {
                            isLoading: false,
                            userCreatedInfo: res?.res?.data,
                            isStudentEnrolledConfirmed: true
                        },
                        () => {
                            this.onShowFeeStructureDetails();
                        }
                    );
                } else {
                    // API call failed - extract and show error message
                    console.log('❌ Enrollment failed - extracting error message');
                    console.log('Response structure:', JSON.stringify(res, null, 2));

                    this.setState({
                        isLoading: false
                    });

                    // Extract error message from various possible formats
                    let errorMessage = 'Some error occurred during enrollment';

                    // Priority 1: Check Service class errMessage (from errorResponse[0].message)
                    if (res?.errMessage) {
                        errorMessage = res.errMessage;
                        console.log('✅ Found error in Service errMessage:', errorMessage);
                    }
                    // Priority 2: Check for errorResponse array in res.res
                    else if (res?.res?.errorResponse && Array.isArray(res.res.errorResponse) && res.res.errorResponse.length > 0) {
                        errorMessage = res.res.errorResponse[0].message || errorMessage;
                        console.log('✅ Found error in res.res.errorResponse array:', errorMessage);
                    }
                    // Priority 3: Check for errorResponse array at root res level
                    else if (res?.errorResponse && Array.isArray(res.errorResponse) && res.errorResponse.length > 0) {
                        errorMessage = res.errorResponse[0].message || errorMessage;
                        console.log('✅ Found error in res.errorResponse array:', errorMessage);
                    }
                    // Priority 4: Check res.res.message
                    else if (res?.res?.message) {
                        errorMessage = res.res.message;
                        console.log('✅ Found error in res.res.message:', errorMessage);
                    }
                    // Priority 5: Check root res.message
                    else if (res?.message) {
                        errorMessage = res.message;
                        console.log('✅ Found error in res.message:', errorMessage);
                    }

                    console.log('📢 Final error message to display:', errorMessage);
                    console.log('📢 Toast reference:', this.toast);
                    console.log('📢 Toast has show method:', this.toast && typeof this.toast.show === 'function');

                    // Show toast notification - use setTimeout to ensure DOM is ready
                    setTimeout(() => {
                        if (this.toast && typeof this.toast.show === 'function') {
                            console.log('📢 Showing toast with error message');
                            this.toast.show({
                                severity: 'error',
                                summary: 'Enrollment Failed',
                                detail: errorMessage,
                                life: 5000
                            });
                        } else {
                            console.error('❌ Toast not available - this.toast:', this.toast);
                            alert('Enrollment Failed: ' + errorMessage);
                        }
                    }, 100);
                }
            })
            .catch((e) => {
                // This catch block should rarely be hit since Service class handles errors in .then()
                console.log('❌ addUser API Error (catch block - unexpected):', e);

                this.setState({
                    isLoading: false
                });

                const errorMessage = e?.message || 'Unexpected error occurred';
                console.log('📢 Error in catch:', errorMessage);

                if (this.toast && typeof this.toast.show === 'function') {
                    this.toast.show({
                        severity: 'error',
                        summary: 'Enrollment Failed',
                        detail: errorMessage,
                        life: 5000
                    });
                } else {
                    alert('Enrollment Failed: ' + errorMessage);
                }
            });
    };

    onShowFeeStructureDetails = async () => {
        const { enrollment } = this.state;
        this.setState({ isOptedForTransport: enrollment?.transportRequired || false });

        if (enrollment?.transportRequired) {
            await this.getTransportFeeStructure();
        }
        await this.getFeeStructures();
        this.setState({ isShowFeeStructure: true });
    };

    getTransportFeeStructure = async () => {
        this.setState({ isLoading: true });
        const { enrollment } = this.state;
        let academicYear = enrollment?.academicSession || localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/fee-structure/transportfees?academicYear=${academicYear}&isNew=${true}`;

        try {
            const res = await this.service.get(url, true);
            if (res && res.status && res.res.status) {
                if (res.res.data && res.res?.data?.length) {
                    this.setState({
                        isLoading: false,
                        feeStructure: res.res.data || []
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            } else {
                this.setState({ isLoading: false });
                if (this.toast.current) {
                    this.toast.current.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            }
        } catch (e) {
            this.setState({ isLoading: false });
            if (this.toast) {
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occurred', life: 3000 });
            }
            console.log(e);
        }
    };

    getFeeStructures = async () => {
        this.setState({ isLoading: true });
        const { enrollment } = this.state;

        const params = new URLSearchParams({
            academicYear: enrollment?.academicSession || '',
            branchId: enrollment?.branch || ''
        });

        let url = `${baseUrlAdmin}/fee-structure?${params.toString()}`;
        console.log('Fetching Fee Structures with URL:', url);

        try {
            const res = await this.service.get(url, true);
            console.log('Fee Structure API Response:', res);
            if (res && res.status && res.res.status) {
                const feeData = res.res.data?.response || res.res.data || [];
                console.log('Fee Structure Data:', feeData);

                if (feeData && feeData.length > 0) {
                    const mappedFeeStructures = feeData.map(item => {
                        let idValue = item._id;
                        if (item._id && item._id.buffer) {
                            const buffer = new Uint8Array(item._id.buffer);
                            idValue = Array.from(buffer)
                                .map(b => b.toString(16).padStart(2, '0'))
                                .join('');
                        } else if (typeof item._id === 'object' && item._id !== null) {
                            idValue = item._id.toString();
                        }

                        return {
                            id: idValue || item.id || item.feeStructureId,
                            feeStructureName: item.scheduleName || item.feeStructureName || item.name,
                            ...item
                        };
                    });

                    console.log('Mapped Fee Structures:', mappedFeeStructures);

                    this.setState({
                        isLoading: false,
                        feeStructureR: mappedFeeStructures
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        feeStructureR: []
                    });
                    if (this.toast.current) {
                        this.toast.current.show({
                            severity: 'error',
                            summary: 'No Fee Structures found.',
                            detail: 'No fee structures available for the selected branch and academic year.',
                            life: 3000
                        });
                    }
                }
            } else {
                this.setState({
                    isLoading: false,
                    feeStructureR: []
                });
                if (this.toast.current) {
                    this.toast.current.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            }
        } catch (e) {
            this.setState({
                isLoading: false,
                feeStructureR: []
            });
            if (this.toast) {
                this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
            }
            console.log(e);
        }
    };

    getSelectedFeeStructure = async (selectedFeeStructure, isRegularStructure) => {
        if (selectedFeeStructure) {
            this.setState({ isLoading: true });

            const { enrollment } = this.state;
            let url = `${baseUrlAdmin}/fee-structure/selectedFee/${selectedFeeStructure}?academicYear=${enrollment?.academicSession || localStorage.getItem('userAcademicYear')}`;
            console.log("Selected Fee Structure URL:=========", url);

            try {
                const res = await this.service.get(url, true);
                if (res && res.status && res.res.status) {
                    if (res.res.data && res.res?.status) {
                        this.setState({
                            isLoading: false,
                            ...(isRegularStructure && { regularFeeStructureDetails: res.res.data }),
                            ...(!isRegularStructure && { feeStructureDetails: res.res.data })
                        });
                    }
                } else {
                    this.setState({ isLoading: false });
                    if (this.toast) {
                        this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                    }
                }
            } catch (e) {
                this.setState({ isLoading: false });
                if (this.toast) {
                    this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
                }
                console.log(e);
            }
        }
    };




    feeStructureAssign = (isRegularFee) => {
        const { userCreatedInfo } = this.state;
        this.setState({ isLoading: true });
        let inputKey = userCreatedInfo?.user_info?.sectionId ? 'user_id' : '';

        console.log('=== Fee Schedule Assignment Debug ===');
        console.log('isRegularFee:', isRegularFee);
        console.log('userCreatedInfo:', userCreatedInfo);
        console.log('inputKey:', inputKey);

        if (inputKey == '') {
            // Error Msg Section is not assigned to user
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: `Error`, detail: 'Section is not assigned to user', life: 3000 });
            return;
        } let feeTypes = [];
        let feeStructureDetails = [];
        let selectedFeeStructure;

        if (!isRegularFee) {
            feeStructureDetails = this.state.feeStructureDetails;
            this.state.feeStructureDetails?.stepOne?.map((each) => feeTypes.push(each?.feeTypeId));
            selectedFeeStructure = this.state?.selectedFeeStructure;
        } else {
            feeStructureDetails = this.state.regularFeeStructureDetails;
            this.state.regularFeeStructureDetails?.stepOne?.map((each) => feeTypes.push(each?.feeTypeId));
            selectedFeeStructure = this.state?.selectedRFeeStructure;
        }

        console.log('feeStructureDetails:', feeStructureDetails);
        console.log('selectedFeeStructure ID:', selectedFeeStructure);
        console.log('feeTypes extracted:', feeTypes);
        console.log('feeTypes length:', feeTypes?.length);

        // Validation checks
        if (!selectedFeeStructure) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Validation Error', detail: 'Please select a fee schedule', life: 3000 });
            return;
        } if (!feeStructureDetails?.feeCategory) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Validation Error', detail: 'Fee category is missing', life: 3000 });
            return;
        } if (!feeTypes?.length) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Validation Error', detail: 'No fee types found in the selected schedule', life: 3000 });
            return;
        } let payload = {
            branchId: userCreatedInfo?.user_info?.branchId,
            boardId: userCreatedInfo?.user_info?.boardId,
            classId: userCreatedInfo?.user_info?.classId,
            sectionId: userCreatedInfo?.user_info?.sectionId,
            academicYear: userCreatedInfo?.user_info?.academicYear,
            feeCategoryId: feeStructureDetails?.feeCategory,
            feeStructureId: selectedFeeStructure,
            feeTypes: feeTypes,
            assignedInfo: [
                {
                    [inputKey]: userCreatedInfo?.user_id
                }
            ]
        };

        console.log('Assignment Payload:', JSON.stringify(payload, null, 2));

        let url = `${baseUrlAdmin}/fee-structure/assign`;
        console.log('API URL:', url);

        this.service
            .post(url, payload, true)
            .then((res) => {
                console.log('API Response:', res);
                if (res?.status && res?.res?.status) {
                    this.setState({
                        isLoading: false,
                        ...(isRegularFee && { isRegularFeeStructureAssigned: true, regularFeeStructureDetails: "" }),
                        ...(!isRegularFee && { isFeeStructureAssigned: true, feeStructureDetails: "" })
                    });
                    this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message || 'Fee schedule assigned successfully', life: 3000 });
                    console.log('✓ Fee schedule assignment successful');
                } else {
                    this.setState({ isLoading: false });
                    console.error('Assignment failed - Response status false:', res);
                    this.toast.show({ severity: 'error', summary: 'Assignment Failed', detail: res?.res?.message || res.errMessage || 'Failed to assign fee schedule', life: 3000 });
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false });
                console.error('Assignment error:', err);
                this.toast.show({ severity: 'error', summary: 'Error', detail: err.message || 'An error occurred while assigning fee schedule', life: 3000 });
            });
    }; onCloseOfFeeStructure = () => {
        this.setState({ isCloseOfFeeStructure: true });
    };

    showConfirmDialog = () => {
        this.setState({ isCredeintalsDisplay: true, isShowFeeStructure: false });
    };

    onGoBack = () => {
        // Navigate back to enrollment form
        this.props.navigate('/confirm-enrollment');
    };

    onPrintEnrollment = () => {
        // Create a new window for printing
        const printWindow = window.open('', '_blank', 'width=800,height=600');

        if (printWindow) {
            const printContent = this.generatePrintContent();
            printWindow.document.write(printContent);
            printWindow.document.close();

            // Wait for content to load then print
            printWindow.onload = () => {
                printWindow.focus();
                printWindow.print();
                // Close the window after printing
                setTimeout(() => {
                    printWindow.close();
                }, 1000);
            };
        }
    };

    generatePrintContent = () => {
        const { enrollment, parents, receiptInfo } = this.state;
        const academicCategoryName = this.getAcademicCategoryName();
        const academicYearCode = this.getAcademicYearCode();

        return `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Enrollment Details - ${enrollment?.firstName || ''} ${enrollment?.lastName || ''}</title>
                <style>
                    @page {
                        size: A4;
                        margin: 20mm;
                    }
                    
                    body {
                        font-family: 'Arial', sans-serif;
                        font-size: 12px;
                        line-height: 1.4;
                        color: #333;
                        margin: 0;
                        padding: 0;
                    }
                    
                    .print-container {
                        max-width: 100%;
                        margin: 0 auto;
                    }
                    
                    .header {
                        text-align: center;
                        border-bottom: 2px solid #333;
                        padding-bottom: 15px;
                        margin-bottom: 20px;
                    }
                    
                    .header h1 {
                        margin: 0;
                        font-size: 20px;
                        font-weight: bold;
                        color: #333;
                    }
                    
                    .header h2 {
                        margin: 5px 0 0 0;
                        font-size: 16px;
                        color: #666;
                        font-weight: normal;
                    }
                    
                    .section {
                        margin-bottom: 25px;
                        page-break-inside: avoid;
                    }
                    
                    .section-title {
                        font-size: 14px;
                        font-weight: bold;
                        color: #333;
                        border-bottom: 1px solid #ccc;
                        padding-bottom: 5px;
                        margin-bottom: 15px;
                    }
                    
                    .info-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-bottom: 15px;
                    }
                    
                    .info-table td {
                        padding: 6px 10px;
                        border-bottom: 1px solid #eee;
                        vertical-align: top;
                    }
                    
                    .info-table .label {
                        font-weight: bold;
                        width: 30%;
                        color: #555;
                    }
                    
                    .info-table .value {
                        width: 70%;
                        color: #333;
                    }
                    
                    .student-photo {
                        position: absolute;
                        top: 120px;
                        right: 0px;
                        border: 2px solid #333;
                        border-radius: 5px;
                        width: 120px;
                        height: 140px;
                        object-fit: cover;
                    }
                    
                    .basic-info-container {
                        position: relative;
                        padding-right: 150px;
                    }
                    
                    .footer {
                        position: fixed;
                        bottom: 20mm;
                        left: 20mm;
                        right: 20mm;
                        text-align: center;
                        font-size: 10px;
                        color: #888;
                        border-top: 1px solid #ccc;
                        padding-top: 10px;
                    }
                    
                    @media print {
                        body {
                            font-size: 11px;
                        }
                        
                        .section {
                            margin-bottom: 20px;
                        }
                        
                        .no-print {
                            display: none;
                        }
                    }
                </style>
            </head>
            <body>
                <div class="print-container">
                    <div class="header">
                        <h1>Student Enrollment Details</h1>
                        <h2>Academic Year: ${academicYearCode}</h2>
                    </div>
                    
                    ${enrollment?.studentPhoto?.storageLocation ?
                `<img src="${enrollment.studentPhoto.storageLocation}" class="student-photo" alt="Student Photo" />` :
                ''
            }
                    
                    <div class="section">
                        <div class="basic-info-container">
                            <div class="section-title">Basic Information</div>
                            <table class="info-table">
                                <tr>
                                    <td class="label">Student Name:</td>
                                    <td class="value">${enrollment?.firstName || ''} ${enrollment?.lastName || ''}</td>
                                </tr>
                                ${parents?.map(parent => `
                                    <tr>
                                        <td class="label">${parent.parentType} Name:</td>
                                        <td class="value">${parent?.parentName || ''}</td>
                                    </tr>
                                `).join('')}
                                <tr>
                                    <td class="label">Date of Birth:</td>
                                    <td class="value">${enrollment?.dob ? moment(enrollment.dob).format('DD/MM/YYYY') : ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Contact No:</td>
                                    <td class="value">${enrollment?.contactNo || ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Email ID:</td>
                                    <td class="value">${enrollment?.emailId || ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">ID Details:</td>
                                    <td class="value">${enrollment?.idDetails || ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Mother Tongue:</td>
                                    <td class="value">${enrollment?.motherTongue || ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Nationality:</td>
                                    <td class="value">${enrollment?.nationality || ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Religion:</td>
                                    <td class="value">${enrollment?.religion || ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Caste:</td>
                                    <td class="value">${enrollment?.caste || ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Identification Marks:</td>
                                    <td class="value">${enrollment?.identificationMarks || ''}</td>
                                </tr>
                                <tr>
                                    <td class="label">Address:</td>
                                    <td class="value">${enrollment?.addressLine || ''} ${enrollment?.cityOrDist || ''} ${enrollment?.state || ''} ${enrollment?.pinCode || ''}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    
                    <div class="section">
                        <div class="section-title">Admission Fee Details</div>
                        <table class="info-table">
                            <tr>
                                <td class="label">Application Fee:</td>
                                <td class="value">₹ ${receiptInfo?.application?.feeAmount || 0}</td>
                            </tr>
                            <tr>
                                <td class="label">Entrance Exam Fee:</td>
                                <td class="value">₹ ${receiptInfo?.exam?.feeAmount || 0}</td>
                            </tr>
                            <tr>
                                <td class="label">Registration Fee:</td>
                                <td class="value">₹ ${receiptInfo?.registration?.feeAmount || 0}</td>
                            </tr>
                            <tr>
                                <td class="label">Enrollment Fee:</td>
                                <td class="value">₹ ${receiptInfo?.enrollment?.feeAmount || 0}</td>
                            </tr>
                        </table>
                    </div>
                    
                    <div class="section">
                        <div class="section-title">Academic Details</div>
                        <table class="info-table">
                            <tr>
                                <td class="label">Application ID:</td>
                                <td class="value">${enrollment?.applicationId || ''}</td>
                            </tr>
                            <tr>
                                <td class="label">Admission Category:</td>
                                <td class="value">${academicCategoryName}</td>
                            </tr>
                            <tr>
                                <td class="label">Admission Date:</td>
                                <td class="value">${enrollment?.createdAt ? moment(enrollment.createdAt).format('DD/MM/YYYY') : ''}</td>
                            </tr>
                            <tr>
                                <td class="label">Branch:</td>
                                <td class="value">${enrollment?.branchName || ''}</td>
                            </tr>
                            <tr>
                                <td class="label">Board:</td>
                                <td class="value">${enrollment?.boardName || ''}</td>
                            </tr>
                            <tr>
                                <td class="label">Grade:</td>
                                <td class="value">${enrollment?.gradeName || ''}</td>
                            </tr>
                            <tr>
                                <td class="label">Exam/Test:</td>
                                <td class="value">${enrollment?.exam?.score || 'N/A'}</td>
                            </tr>
                        </table>
                    </div>
                    
                   
                </div>
            </body>
            </html>
        `;
    };

    // <div class="footer">
    //     <p>Generated on: ${moment().format('DD/MM/YYYY HH:mm:ss')} | Student Enrollment Report</p>
    // </div>

    render() {
        const { enrollment, parents, receiptInfo, isLoading } = this.state;

        if (isLoading) {
            return <LoadingComponent />;
        }

        return (
            <div className="preview-enrollment-container">
                <Toast ref={(el) => {
                    if (el && typeof el.show === 'function') {
                        this.toast = el;
                    }
                }} />
                <div className="card">
                    <div className="card-header">
                        <h2>Preview Enrollment Details</h2>
                    </div>

                    <div className="card-body">
                        <div className="">
                            <div className="grid col-12">
                                <div className="sm:col-12 md:col-10">
                                    <h3 className="text-left md:ml-3 my-5">Basic Information</h3>
                                    <div className="grid md:col-12 row-gap-0 column-gap-0">
                                        <div className="col-4 my-0 py-1 view-header">
                                            <h5>Student Name </h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {`${enrollment?.firstName || ''} ${enrollment?.lastName || ''}`}</h5>
                                        </div>

                                        {/* {parents?.map((parent, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <div className="col-4 my-0 py-1 view-header">
                                                        <h5>{parent.parentType} Name </h5>
                                                    </div>
                                                    <div className="col-8 my-0 py-1">
                                                        <h5>: {parent?.parentName}</h5>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        })} */}

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>DOB</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.dob ? moment(enrollment.dob).format('DD/MM/YYYY') : ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Contact No</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.contactNo || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Email ID</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.emailId || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>ID Details</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.idDetails || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Mother Tongue</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.motherTongue || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Nationality</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.nationality || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Religion</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.religion || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Caste</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.caste || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Identification Marks</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.identificationMarks || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Address</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>
                                                :{' '}
                                                {`${enrollment?.addressLine || ''} ${enrollment?.cityOrDist || ''} ${enrollment?.state || ''} ${enrollment?.pinCode || ''}`}
                                            </h5>
                                        </div>
                                    </div>

                                    <h3 className="text-left md:ml-3 mr-5 my-5">Admission Fee Details</h3>
                                    <div className="grid flex md:col-12 row-gap-0 column-gap-0">
                                        <div className="col-4 my-0 py-1 view-header">
                                            <h5>Application Fee</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {receiptInfo?.application?.feeAmount || 0}</h5>
                                        </div>
                                        <div className="col-4 my-0 py-1 view-header">
                                            <h5>Entrance Exam Fee</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {receiptInfo?.exam?.feeAmount || 0}</h5>
                                        </div>
                                        <div className="col-4 my-0 py-1 view-header">
                                            <h5>Registration Fee</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {receiptInfo?.registration?.feeAmount || 0}</h5>
                                        </div>
                                        <div className="col-4 my-0 py-1 view-header">
                                            <h5>Enrollment Fee</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {receiptInfo?.enrollment?.feeAmount || 0}</h5>
                                        </div>
                                    </div>

                                    <h3 className="text-left md:ml-3 mr-5 my-5">Academic Details</h3>
                                    <div className="grid flex md:col-12 row-gap-0 column-gap-0">
                                        <div className="col-4 my-0 py-1 view-header">
                                            <h5>Application ID</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.applicationId || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Academic Year</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {this.getAcademicYearCode()}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Admission Category</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {this.getAcademicCategoryName()}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Admission Date</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.createdAt ? moment(enrollment.createdAt).format('DD/MM/YYYY') : ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Branch</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.branchName || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Board</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.boardName || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Grade</h5>
                                        </div>
                                        <div className="col-8 my-0  py-1">
                                            <h5>: {enrollment?.gradeName || ''}</h5>
                                        </div>

                                        <div className="col-4 my-0 py-1 view-header ">
                                            <h5>Exam/Test</h5>
                                        </div>
                                        <div className="col-8 my-0 py-1">
                                            <h5>: {enrollment?.exam?.score || 'N/A'}</h5>
                                        </div>
                                    </div>
                                </div>
                                {(enrollment?.studentPhoto?.storageLocation) && (
                                    <div className="md:col-2 sm:col-12 text-right ">
                                        <img
                                            src={enrollment?.studentPhoto?.storageLocation}
                                            className="logo-img"
                                            style={{ marginLeft: '10%', width: '201px', height: '207px' }}
                                            alt="Student Photo"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="card-footer text-center mt-4">
                        <Button
                            label="Print (A4)"
                            onClick={this.onPrintEnrollment}
                            className="formSubmitButton px-4 mr-3"
                            style={{ borderRadius: '10px', backgroundColor: '#076EFF', border: 'none', width: '18rem', padding: '12px' }}
                        // icon="pi pi-print"
                        />
                        <Button
                            label="Confirm Enrollment"
                            onClick={this.onConfirmEnrollment}
                            disabled={this.state.isAlreadyEnrolled}
                            className="formSubmitButton px-4 mr-3"
                            style={{
                                borderRadius: '10px',
                                backgroundColor: this.state.isAlreadyEnrolled ? '#ccc' : '#076EFF',
                                border: 'none',
                                width: '18rem',
                                padding: '12px',
                                cursor: this.state.isAlreadyEnrolled ? 'not-allowed' : 'pointer'
                            }}
                        // icon="pi pi-check"
                        />
                        <Button
                            label="Go Back"
                            onClick={this.onGoBack}
                            className="formCancelButton px-4"
                            style={{ borderRadius: '10px', backgroundColor: 'gray', border: 'none', width: '18rem', padding: '12px' }}
                        // icon="pi pi-arrow-left"
                        />
                    </div>
                </div>

                {/* Fee Structure Assignment Dialog */}
                <Dialog
                    visible={this.state.isShowFeeStructure}
                    style={this.state.isFeeDialogMaximized ? { width: '95vw', height: '95vh' } : { width: '75vw', height: '80vh' }}
                    draggable={false}
                    onHide={() => this.onCloseOfFeeStructure()}
                    closable={true}
                    maximizable={false}
                    header={() => {
                        return (
                            <div className="p-2">
                                <div className="flex justify-content-between align-items-center">
                                    <h3 className="text-center formhead flex-grow-1 m-0">Student Enrollment Confirmed - Assign Fee Schedule</h3>
                                    <Button
                                        icon={this.state.isFeeDialogMaximized ? "pi pi-window-minimize" : "pi pi-window-maximize"}
                                        className="p-button-rounded p-button-text p-button-plain"
                                        onClick={() => this.setState({ isFeeDialogMaximized: !this.state.isFeeDialogMaximized })}
                                        tooltip={this.state.isFeeDialogMaximized ? "Minimize" : "Maximize"}
                                        tooltipOptions={{ position: 'bottom' }}
                                        style={{ marginRight: '40px' }}
                                    />
                                </div>
                                {this.state?.userCreatedInfo && (
                                    <>
                                        <div className="flex flex-column align-items-center justify-content-center">
                                            <p>
                                                <span className="enrolledDataHeaders">Enrollment Id :</span>
                                                <span className="enrolledData">{this.state?.userCreatedInfo?.enrollmentId}</span>
                                            </p>
                                            <p>
                                                <span className="enrolledDataHeaders">Branch :</span>
                                                <span className="enrolledData">{this.state?.userCreatedInfo?.user_info?.branchName}</span>
                                            </p>
                                            <p>
                                                <span className="enrolledDataHeaders">Grade :</span>
                                                <span className="enrolledData">{this.state?.userCreatedInfo?.user_info?.['custom:grade']}</span>
                                            </p>
                                        </div>
                                    </>
                                )}
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center p-3" style={{ borderTop: '1px solid #dee2e6' }}>
                            <Button
                                label="Assign"
                                className="p-button-primary submitButtonn mr-4 button text-lg "
                                style={{ width: "150px" }}
                                onClick={() => this.feeStructureAssign(true)}
                                disabled={this.state.isRegularFeeStructureAssigned}
                            />
                            {!this.state.isRegularFeeStructureAssigned && (
                                <Button
                                    className="cancelButtonn w-1 mr-4"
                                    onClick={() => this.onCloseOfFeeStructure()}
                                >
                                    <p className="cancelButtonnText">Cancel</p>
                                </Button>
                            )}
                            {this.state.isRegularFeeStructureAssigned && (
                                <Button
                                    label="View Student Details"
                                    className="p-button-primary submitButtonn mr-4 button text-lg "
                                    disabled={!this.state?.isRegularFeeStructureAssigned || (this.state?.isOptedForTransport && !this.state?.isFeeStructureAssigned)}
                                    onClick={() => {
                                        if (this.state?.isRegularFeeStructureAssigned || (this.state?.isOptedForTransport && this.state?.isFeeStructureAssigned)) {
                                            this.showConfirmDialog();
                                        }
                                    }}
                                />
                            )}
                        </div>
                    )}
                >
                    <div className="mb-5 ml-5 mr-5 p-2" style={{ maxHeight: 'calc(95vh - 250px)', overflowY: 'auto' }}>
                        <div className="flex ">
                            <div className=" ">
                                <label className="label">
                                    Fee Schedule<span className="ma-required">*</span>
                                </label>
                                <div className='flex'>
                                    <div className="mt-3">
                                        <ClassetDropdown
                                            options={this.state.feeStructureR}
                                            optionLabel="feeStructureName"
                                            optionValue="id"
                                            width={250}
                                            filter
                                            showClear
                                            filterBy="feeStructureName"
                                            value={this.state.selectedRFeeStructure}
                                            onChange={(e) => this.setState({ selectedRFeeStructure: e.target.value }, () => this.getSelectedFeeStructure(this.state.selectedRFeeStructure, true))}
                                            placeholder="Select Fee Schedule"
                                            disabled={this.state.isRegularFeeStructureAssigned}
                                        />
                                    </div>
                                    {this.state.selectedRFeeStructure && (
                                        <div className="mt-3 p-3" style={{
                                            backgroundColor: '#FEF3C7',
                                            border: '1px solid #FCD34D',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '10px',
                                            marginLeft: '10px'
                                        }}>
                                            <i className="pi pi-info-circle" style={{
                                                color: '#D97706',
                                                fontSize: '18px',
                                                marginTop: '2px'
                                            }}></i>
                                            <div style={{ flex: 1 }}>
                                                <p className="m-0" style={{
                                                    color: '#92400E',
                                                    fontSize: '14px',
                                                    lineHeight: '1.5',
                                                    fontWeight: '500'
                                                }}>
                                                    Below fees and installments correspond to the selected Fee Schedule; upon assignment, the student will be enrolled with fees based on their Admission Type.
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Fee Schedule Preview */}
                        {this.state?.regularFeeStructureDetails && this.state?.regularFeeStructureDetails?.stepTwo && (
                            <div className="mt-4 p-3">
                                {/* Fee Schedule Summary */}
                                <div className="mb-4 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                    <h4 className="text-xl font-semibold mb-3">Fee Schedule Summary</h4>
                                    <div className="grid">
                                        <div className="col-4">
                                            <p><strong>Total Fee Types:</strong> {this.state?.regularFeeStructureDetails?.stepOne?.length || 0}</p>
                                        </div>
                                        <div className="col-4">
                                            <p><strong>Total Amount:</strong> ₹{this.state?.regularFeeStructureDetails?.stepOne?.reduce((sum, fee) => sum + (parseFloat(fee.totalFee) || 0), 0).toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* One-time Fees Section */}
                                {this.state?.regularFeeStructureDetails?.stepTwo?.filter(fee => fee.isOneTime)?.length > 0 && (
                                    <div className="mb-4">
                                        <h4 className="text-xl font-semibold mb-2">One Time Fees</h4>
                                        <DataTable
                                            value={this.state?.regularFeeStructureDetails?.stepTwo?.filter(fee => fee.isOneTime).sort((a, b) => (a.priority || 999) - (b.priority || 999))}
                                            responsiveLayout="scroll"
                                        >
                                            <Column
                                                header="Priority"
                                                body={(rowData, index) => index.rowIndex + 1}
                                                style={{ width: '80px' }}
                                            />
                                            <Column field="feeType" header="Fee Type" />
                                            <Column
                                                field="totalFee"
                                                header="Amount"
                                                body={(rowData) => `₹${parseFloat(rowData.totalFee || 0).toFixed(2)}`}
                                            />
                                            <Column
                                                header="Due Date"
                                                body={(rowData) => (
                                                    <span>{rowData.dueDate ? moment(rowData.dueDate).format('DD/MM/YYYY') : 'Not set'}</span>
                                                )}
                                            />
                                        </DataTable>
                                    </div>
                                )}

                                {/* Installment-based Fees */}
                                {(() => {
                                    const installmentGroups = {};
                                    this.state?.regularFeeStructureDetails?.stepTwo?.forEach(fee => {
                                        if (!fee.isOneTime && fee.installmentId) {
                                            if (!installmentGroups[fee.installmentId]) {
                                                installmentGroups[fee.installmentId] = [];
                                            }
                                            installmentGroups[fee.installmentId].push(fee);
                                        }
                                    });

                                    return Object.keys(installmentGroups).length > 0 && Object.entries(installmentGroups).map(([installmentId, fees], index) => {
                                        const totalInstallmentAmount = fees.reduce((sum, fee) => sum + (parseFloat(fee.termWiseActualValue) || 0), 0);
                                        const dueDate = fees[0]?.dueDate;

                                        return (
                                            <div key={installmentId} className="mb-4">
                                                <div className="flex align-items-center gap-3 mb-2">
                                                    <h4 className="m-0">
                                                        Installment {index + 1} - {dueDate ? moment(dueDate).format('DD/MM/YYYY') : 'Date not set'}
                                                    </h4>
                                                    <span className="text-primary font-semibold">Total: ₹{totalInstallmentAmount.toFixed(2)}</span>
                                                </div>
                                                <DataTable value={fees.sort((a, b) => (a.priority || 999) - (b.priority || 999))} responsiveLayout="scroll">
                                                    <Column
                                                        header="Priority"
                                                        body={(rowData, index) => index.rowIndex + 1}
                                                        style={{ width: '80px' }}
                                                    />
                                                    <Column field="feeType" header="Fee Type" />
                                                    <Column
                                                        header="Total Fee"
                                                        body={(rowData) => {
                                                            const feeTypeData = this.state?.regularFeeStructureDetails?.stepOne?.find(f => f.feeTypeId === rowData.feeTypeId);
                                                            return `₹${parseFloat(feeTypeData?.totalFee || 0).toFixed(2)}`;
                                                        }}
                                                    />
                                                    <Column
                                                        header="Percentage"
                                                        body={(rowData) => `${parseFloat(rowData.termWisePercentageOrValue || 0).toFixed(2)}%`}
                                                    />
                                                    <Column
                                                        header="Installment Amount"
                                                        body={(rowData) => `₹${parseFloat(rowData.termWiseActualValue || 0).toFixed(2)}`}
                                                    />
                                                </DataTable>
                                            </div>
                                        );
                                    });
                                })()}
                            </div>
                        )}

                        {this.state.isLoading && <LoadingComponent />}
                    </div>
                </Dialog>

                {/* Enrollment Confirmation Dialog */}
                <Dialog
                    visible={this.state.isCredeintalsDisplay}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: '520px', maxWidth: '90vw', borderRadius: '16px' }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (
                            <div className="text-center pt-4 pb-2">
                                <div className="flex justify-content-center mb-4">
                                    <div style={{
                                        width: '72px',
                                        height: '72px',
                                        borderRadius: '50%',
                                        backgroundColor: '#10B981',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)'
                                    }}>
                                        <i className="pi pi-check" style={{ fontSize: '36px', color: 'white', fontWeight: 'bold' }}></i>
                                    </div>
                                </div>
                                <h2 style={{
                                    fontWeight: '700',
                                    fontSize: '24px',
                                    color: '#1F2937',
                                    margin: 0,
                                    fontFamily: 'InterSemiBold'
                                }}>Enrollment Confirmed!</h2>
                                <p style={{
                                    color: '#6B7280',
                                    fontSize: '14px',
                                    marginTop: '8px',
                                    fontFamily: 'InterRegular'
                                }}>Student has been successfully enrolled</p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center pb-4 pt-2">
                            <Button
                                className="formSubmitButton"
                                style={{
                                    borderRadius: '12px',
                                    backgroundColor: '#076EFF',
                                    border: 'none',
                                    padding: '14px 40px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    boxShadow: '0 2px 8px rgba(7, 110, 255, 0.25)',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={() => {
                                    this.setState({ isCredeintalsDisplay: false, studentDetails: true });
                                }}
                            >
                                <span style={{ fontFamily: 'InterSemiBold' }}>View Student Details</span>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isCredeintalsDisplay: false })}
                >
                    <div className="px-4 py-3" style={{ backgroundColor: '#F9FAFB', borderRadius: '12px', margin: '0 24px 24px 24px' }}>
                        {this.state?.userCreatedInfo && (
                            <div className="flex flex-column" style={{ gap: '16px' }}>
                                <div style={{
                                    backgroundColor: 'white',
                                    padding: '16px',
                                    borderRadius: '10px',
                                    border: '1px solid #E5E7EB',
                                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                                }}>
                                    <div className="flex align-items-center justify-content-between mb-2">
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#6B7280',
                                            fontWeight: '500',
                                            fontFamily: 'InterMedium',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>Enrollment ID</span>
                                    </div>
                                    <div style={{
                                        fontSize: '18px',
                                        fontWeight: '700',
                                        color: '#076EFF',
                                        fontFamily: 'InterBold',
                                        letterSpacing: '0.5px'
                                    }}>
                                        {this.state?.userCreatedInfo?.enrollmentId}
                                    </div>
                                </div>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: '12px'
                                }}>
                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '14px',
                                        borderRadius: '8px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#9CA3AF',
                                            marginBottom: '6px',
                                            fontFamily: 'InterRegular'
                                        }}>Branch</div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1F2937',
                                            fontFamily: 'InterSemiBold'
                                        }}>
                                            {this.state?.userCreatedInfo?.user_info?.branchName}
                                        </div>
                                    </div>

                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '14px',
                                        borderRadius: '8px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#9CA3AF',
                                            marginBottom: '6px',
                                            fontFamily: 'InterRegular'
                                        }}>Board</div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1F2937',
                                            fontFamily: 'InterSemiBold'
                                        }}>
                                            {this.state?.userCreatedInfo?.user_info?.['custom:board']}
                                        </div>
                                    </div>

                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '14px',
                                        borderRadius: '8px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#9CA3AF',
                                            marginBottom: '6px',
                                            fontFamily: 'InterRegular'
                                        }}>Grade</div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1F2937',
                                            fontFamily: 'InterSemiBold'
                                        }}>
                                            {this.state?.userCreatedInfo?.user_info?.['custom:grade']}
                                        </div>
                                    </div>

                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '14px',
                                        borderRadius: '8px',
                                        border: '1px solid #E5E7EB'
                                    }}>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#9CA3AF',
                                            marginBottom: '6px',
                                            fontFamily: 'InterRegular'
                                        }}>Section</div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1F2937',
                                            fontFamily: 'InterSemiBold'
                                        }}>
                                            {this.state?.userCreatedInfo?.user_info?.sectionName}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Dialog>

                {/* Student Details/Credentials Dialog */}
                <Dialog
                    visible={this.state.studentDetails}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: '700px', maxWidth: '90vw', borderRadius: '16px' }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (
                            <div className="text-center pt-4 pb-3">
                                <div className="flex justify-content-center mb-4">
                                    <div style={{
                                        width: '64px',
                                        height: '64px',
                                        borderRadius: '50%',
                                        backgroundColor: '#EFF6FF',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '3px solid #DBEAFE'
                                    }}>
                                        <i className="pi pi-key" style={{ fontSize: '28px', color: '#076EFF' }}></i>
                                    </div>
                                </div>
                                <h2 style={{
                                    fontWeight: '700',
                                    fontSize: '26px',
                                    lineHeight: '1.3',
                                    color: '#1F2937',
                                    marginBottom: '8px',
                                    fontFamily: 'InterBold'
                                }}>LMS & ERP</h2>
                                <h3 style={{
                                    fontWeight: '600',
                                    fontSize: '22px',
                                    lineHeight: '1.3',
                                    color: '#076EFF',
                                    marginTop: '0',
                                    fontFamily: 'InterSemiBold'
                                }}>Login Credentials</h3>
                                <p style={{
                                    color: '#6B7280',
                                    fontSize: '14px',
                                    marginTop: '8px',
                                    fontFamily: 'InterRegular'
                                }}>Share these credentials with the student and parent</p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center pb-4 pt-3" style={{ gap: '12px' }}>
                            <Button
                                icon="pi pi-times"
                                label="Close"
                                className="p-button-outlined"
                                style={{
                                    borderRadius: '12px',
                                    border: '2px solid #E5E7EB',
                                    color: '#6B7280',
                                    backgroundColor: 'white',
                                    padding: '12px 32px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    minWidth: '140px',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={() => {
                                    this.setState({ isCredeintalsDisplay: false, studentDetails: false });
                                    this.props.navigate('/admission-enrollment');
                                }}
                            />
                        </div>
                    )}
                    onHide={() => this.setState({ studentDetails: false })}
                >
                    <div className="px-4 pb-4" style={{ fontFamily: 'InterRegular' }}>
                        {/* Student Login Credentials Section */}
                        <div className="mb-4">
                            <div style={{
                                backgroundColor: '#F9FAFB',
                                padding: '24px',
                                borderRadius: '12px',
                                border: '1px solid #E5E7EB'
                            }}>
                                <div className="flex align-items-center mb-3" style={{ gap: '10px' }}>
                                    <div style={{
                                        width: '36px',
                                        height: '36px',
                                        borderRadius: '8px',
                                        backgroundColor: '#DBEAFE',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <i className="pi pi-user" style={{ fontSize: '18px', color: '#076EFF' }}></i>
                                    </div>
                                    <h3 style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#1F2937',
                                        margin: 0,
                                        fontFamily: 'InterSemiBold'
                                    }}>Student Login</h3>
                                </div>

                                {this.state?.userCreatedInfo && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '20px' }}>
                                        <div style={{
                                            backgroundColor: 'white',
                                            padding: '16px 20px',
                                            borderRadius: '10px',
                                            border: '1px solid #E5E7EB',
                                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                                        }}>
                                            <div className="flex align-items-center justify-content-between">
                                                <div style={{ flex: 1 }}>
                                                    <div style={{
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        color: '#9CA3AF',
                                                        marginBottom: '6px',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.5px',
                                                        fontFamily: 'InterMedium'
                                                    }}>Username</div>
                                                    <div style={{
                                                        fontSize: '18px',
                                                        fontWeight: '600',
                                                        color: '#1F2937',
                                                        fontFamily: 'InterSemiBold',
                                                        letterSpacing: '0.3px'
                                                    }}>
                                                        {this.state?.userCreatedInfo?.user_info?.username ? this.state.userCreatedInfo.user_info.username.slice(3) : ''}
                                                    </div>
                                                </div>
                                                <Button
                                                    icon="pi pi-copy"
                                                    className="p-button-rounded p-button-text"
                                                    style={{ color: '#076EFF' }}
                                                    onClick={() => {
                                                        const username = this.state?.userCreatedInfo?.user_info?.username ? this.state.userCreatedInfo.user_info.username.slice(3) : '';
                                                        navigator.clipboard.writeText(username);
                                                    }}
                                                    tooltip="Copy username"
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            </div>
                                        </div>

                                        <div style={{
                                            backgroundColor: 'white',
                                            padding: '16px 20px',
                                            borderRadius: '10px',
                                            border: '1px solid #E5E7EB',
                                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                                        }}>
                                            <div className="flex align-items-center justify-content-between">
                                                <div style={{ flex: 1 }}>
                                                    <div style={{
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        color: '#9CA3AF',
                                                        marginBottom: '6px',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.5px',
                                                        fontFamily: 'InterMedium'
                                                    }}>Password</div>
                                                    <div style={{
                                                        fontSize: '18px',
                                                        fontWeight: '600',
                                                        color: '#1F2937',
                                                        fontFamily: 'InterSemiBold',
                                                        letterSpacing: '0.5px'
                                                    }}>
                                                        {(() => {
                                                            const lastName = this.state?.userCreatedInfo?.user_info?.lastName || '';
                                                            const dob = this.state?.userCreatedInfo?.user_info?.dateOfBirth;

                                                            if (!lastName || !dob) return 'Not available';

                                                            const cleanedLastName = lastName.trim().replace(/\s+/g, '');
                                                            const surname4Chars = cleanedLastName
                                                                ? cleanedLastName.slice(0, 4).charAt(0).toUpperCase() + cleanedLastName.slice(1, 4).toLowerCase()
                                                                : '';

                                                            const date = new Date(dob);
                                                            const dd = String(date.getDate()).padStart(2, '0');
                                                            const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                            const yyyy = date.getFullYear();

                                                            return `${surname4Chars}@${dd}${mm}${yyyy}`;
                                                        })()}
                                                    </div>
                                                </div>
                                                <Button
                                                    icon="pi pi-copy"
                                                    className="p-button-rounded p-button-text"
                                                    style={{ color: '#076EFF' }}
                                                    onClick={() => {
                                                        const lastName = this.state?.userCreatedInfo?.user_info?.lastName || '';
                                                        const dob = this.state?.userCreatedInfo?.user_info?.dateOfBirth;
                                                        if (lastName && dob) {
                                                            const cleanedLastName = lastName.trim().replace(/\s+/g, '');
                                                            const surname4Chars = cleanedLastName
                                                                ? cleanedLastName.slice(0, 4).charAt(0).toUpperCase() + cleanedLastName.slice(1, 4).toLowerCase()
                                                                : '';
                                                            const date = new Date(dob);
                                                            const dd = String(date.getDate()).padStart(2, '0');
                                                            const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                            const yyyy = date.getFullYear();
                                                            const password = `${surname4Chars}@${dd}${mm}${yyyy}`;
                                                            navigator.clipboard.writeText(password);
                                                        }
                                                    }}
                                                    tooltip="Copy password"
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Parent Mobile App Login Section */}
                        {this.state?.userCreatedInfo?.user_info?.parentContactNo && (
                            <div>
                                <div style={{
                                    backgroundColor: '#F9FAFB',
                                    padding: '24px',
                                    borderRadius: '12px',
                                    border: '1px solid #E5E7EB'
                                }}>
                                    <div className="flex align-items-center mb-3" style={{ gap: '10px' }}>
                                        <div style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '8px',
                                            backgroundColor: '#DBEAFE',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="pi pi-mobile" style={{ fontSize: '18px', color: '#076EFF' }}></i>
                                        </div>
                                        <h3 style={{
                                            fontSize: '18px',
                                            fontWeight: '600',
                                            color: '#1F2937',
                                            margin: 0,
                                            fontFamily: 'InterSemiBold'
                                        }}>Parent Mobile App</h3>
                                    </div>
                                    <p style={{
                                        color: '#6B7280',
                                        fontSize: '14px',
                                        marginBottom: '16px',
                                        fontFamily: 'InterRegular',
                                        lineHeight: '1.6'
                                    }}>
                                        Parents can download the mobile app and login using their registered contact number
                                    </p>
                                    <div style={{
                                        backgroundColor: 'white',
                                        padding: '16px 20px',
                                        borderRadius: '10px',
                                        border: '1px solid #E5E7EB',
                                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                                    }}>
                                        <div className="flex align-items-center justify-content-between">
                                            <div style={{ flex: 1 }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    color: '#9CA3AF',
                                                    marginBottom: '6px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    fontFamily: 'InterMedium'
                                                }}>Contact Number</div>
                                                <div style={{
                                                    fontSize: '18px',
                                                    fontWeight: '600',
                                                    color: '#1F2937',
                                                    fontFamily: 'InterSemiBold',
                                                    letterSpacing: '0.3px'
                                                }}>
                                                    {this.state?.userCreatedInfo?.user_info?.parentContactNo}
                                                </div>
                                            </div>
                                            <Button
                                                icon="pi pi-copy"
                                                className="p-button-rounded p-button-text"
                                                style={{ color: '#076EFF' }}
                                                onClick={() => {
                                                    navigator.clipboard.writeText(this.state?.userCreatedInfo?.user_info?.parentContactNo);
                                                }}
                                                tooltip="Copy number"
                                                tooltipOptions={{ position: 'top' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Dialog>

                {/* Close Fee Structure Confirmation Dialog */}
                <Dialog
                    visible={this.state.isCloseOfFeeStructure}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (
                            <div className="mt-2 formHeadingInter">
                                <div className="mb-3">
                                    <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                                </div>
                                <p style={{ fontWeight: 'bold', fontSize: 20 }}>Canceling this will leave the fee assignment incomplete for the student. Do you want to proceed?</p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button className="formSubmitButton px-4" style={{ borderRadius: '10px', backgroundColor: '#BF0031', border: 'none' }} onClick={() => this.showConfirmDialog()}>
                                <p className="formSubmitButtonText">Confirm</p>
                            </Button>
                            <Button className="formCancelButton px-4" style={{ backgroundColor: '#F4F5F6', border: 0 }} onClick={() => this.setState({ isCloseOfFeeStructure: false })}>
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isCloseOfFeeStructure: false })}
                ></Dialog>
            </div>
        );
    }
}

export default withRouter(PreviewConfirmEnrollment);
